import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AnnualReportProvider } from '@modeso/aumico-lib-annualreport-fe/provider/annualReport.provider';
import { EditSectionTitleComponent } from '@modeso/aumico-lib-core-fe';
import { IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import Debug from 'debug';
import {
    IFinancialTableData,
    IOptions,
    ISectionData,
    PrintUsingPdfTronDto,
    RowTypes,
} from 'projects/aumico-lib-annualreport-fe/src/public-api';
import { filter, map, tap } from 'rxjs';

const debug = Debug('aumico:aumico-lib-annualreport-fe:CashFlowStatementDisplayComponent');

/**
 * Data passed to the component will be mutated
 */
@UntilDestroy()
@Component({
    selector: 'cash-flow-statement-german-display',
    templateUrl: 'cash-flow-german-display.component.html',
    styleUrls: ['cash-flow-german-display.component.scss'],
})
export class CashFlowStatementGermanDisplayComponent implements OnInit {
    sectionTitle: string;
    @Input() set printOptions(value: IPrintOptions | undefined) {
        if (value != null) {
            this.showRatios = value.displayOptions.showRatios;
            this.textColor = value.styleOptions.textColor;
            this.showNotes = value.displayOptions.showNotes;
            this.backgroundColor = value.styleOptions.backgroundColor;
            this.backgroundColorPY = value.styleOptions.backgroundColorPY;
            this.tableHeaderColor = value.styleOptions.tableHeaderColor;
            this.tableFooterColor = value.styleOptions.tableFooterColor;
        }
    }
    @Input() noPreviousData: boolean;

    @Output() sectionTitleChanged: EventEmitter<string> = new EventEmitter<string>();

    textColor: string;
    backgroundColor: string;
    backgroundColorPY: string;
    tableFooterColor: string;
    tableHeaderColor: string;
    showRatios: boolean;
    showNotes: boolean;
    options: IOptions;
    public sectionData: IFinancialTableData[][];

    constructor(
        private readonly annualReportProvider: AnnualReportProvider,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private dialog: MatDialog,
    ) {
        this.addSvgIcon('aumico-pattern-icon-edit-write');
    }

    ngOnInit(): void {
        this.annualReportProvider
            .getPrintView$()
            .pipe(
                filter(
                    (printViewData: PrintUsingPdfTronDto) => printViewData != null && printViewData.data.cfs != null,
                ),
                map((printViewData: PrintUsingPdfTronDto) => printViewData.data.cfs),
                tap((cfsSection: ISectionData) => (this.sectionTitle = cfsSection.title)),
                map((cfsSection: ISectionData) => {
                    return cfsSection.data as IFinancialTableData[];
                }),
                untilDestroyed(this),
            )
            .subscribe((items) => {
                let data: IFinancialTableData[][] = [[]];
                let currentIndex = 0;

                for (const item of items) {
                    if (item.rowType === RowTypes.TABLE_HEAD) {
                        currentIndex++;
                        data[currentIndex] = [item];
                    } else if (currentIndex >= 0) {
                        data[currentIndex].push(item);
                    }
                }
                data = data.filter((subArray) => subArray.length > 0);
                this.sectionData = data;
            });
    }

    public editSectionTitle(): void {
        const dialogRef = this.dialog.open<EditSectionTitleComponent, string, string | undefined>(
            EditSectionTitleComponent,
            {
                disableClose: false,
                panelClass: 'custom-modalbox',
                data: this.sectionTitle,
            },
        );

        dialogRef
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                if (result != null) {
                    this.sectionTitle = result;
                    this.sectionTitleChanged.emit(result);
                }
            });
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }
}
